import React from 'react';
import HeroSectionML from '../components/sections/HeroSectionML';
import AboutSectionML from '../components/sections/AboutSectionML';
import ServicesSectionML from '../components/sections/ServicesSectionML';
import HighlightSectionML from '../components/sections/HighlightSectionML';
import ProjectsSectionML from '../components/sections/ProjectsSectionML';
import StatsSectionML from '../components/sections/StatsSectionML';
import ClientsSectionML from '../components/sections/ClientsSectionML';
import InsightsSectionML from '../components/sections/InsightsSectionML';
import CTASectionML from '../components/sections/CTASectionML';
import SEOHead from '../components/common/SEOHead';

const NewHomepage = () => {
  return (
    <>
      <SEOHead
        titlePT="Grupo BMP | Arquitetura Empresarial & Gestão Internacional"
        titleEN="Grupo BMP | Global Trading Solutions & International Management"
        descriptionPT="Estruturamos, implementamos e escalamos operações empresariais premium em Dubai, Angola e mercados globais desde 2008."
        descriptionEN="We structure, implement, and scale premium business operations across Dubai, Angola, and global markets since 2008."
        ogImage="https://grupobmp.com/og-image.jpg"
      />
      
      {/* All sections are now multilingual (PT/EN) */}
      <HeroSectionML />
      <AboutSectionML />
      <ServicesSectionML />
      <HighlightSectionML sectionName="highlight_trading" />
      <ProjectsSectionML />
      <StatsSectionML />
      <ClientsSectionML />
      <InsightsSectionML />
      <CTASectionML />
    </>
  );
};

export default NewHomepage;
